'use strict';

$(document).on('einsteincarousel:load', function () {
    plpStructureOldBadges();
})
/**
 *
 */
function init() {
    pdpStructureOldBadges();
};

function badgesReplace(productElement) {
    let parentElement = $(productElement).parent().parent();
    let numberOfBadges = $(productElement).find('.badges-list h4').length;
    let productType = $(productElement).find("[data-tipo-producto]:first").val() || $(productElement).find("[data-tile-tipo-producto]:first").val();

    $(productElement).find('.badge-suscription').each(function(index,element){
        let badgeText = $(element).find('span').text();
        if (badgeText) {
            $(element).replaceWith(  '<h4><span class="badge bg-secondary badge-suscription pink">' + badgeText + '</span></h4>'  );
            numberOfBadges++;
        }
    });

    $(productElement).find('p:has(img)').each(function(index,element){

        let hrefImage = $(element).children('img').attr('src');

        if (hrefImage.includes('Etiqueta%20BS.jpg')) {
            var badgeText = 'Best Seller';
            $(element).replaceWith(  '<h4><span class="badge bg-secondary pink-light">' + badgeText  + '</span></h4>'  );
            numberOfBadges++;
        }

        if (hrefImage.includes('Reciclado-ryk')) {
            var badgeText = 'Eco';
            $(element).replaceWith(  '<h4><span class="badge bg-secondary pink-light">' + badgeText  + '</span></h4>'  );
            numberOfBadges++;
        }

        if (hrefImage.includes('New%20Azul.png')) {
            var badgeText = 'New';
            $(element).replaceWith(  '<h4><span class="badge bg-secondary pink-light">' + badgeText  + '</span></h4>'  );
            numberOfBadges++;
        }
    });

    $(productElement).find('span.badge-name').each(function(index,element) {
        let badgeTextElement = $(element).find('span:first');
        var badgeText = null;
        switch ($(badgeTextElement).text()) {
            case 'K':
                badgeText = 'Kids';
                break;
            case 'T':
                badgeText = 'Teens';
                break;
        }

        if (badgeText) {
            $(element).replaceWith('<h4><span class="badge bg-secondary pink-light">' + badgeText  + '</span></h4>');
        }
    });

    if (productType === 'lenteContacto') {
        $(productElement).find('.badge-suscription:first').each(function(index,element){
            $(element).prependTo($(productElement).find('.badges-list'));
        });
    }

    if (numberOfBadges >= 2) {
        //remove badges only two are allowed
        $(productElement).find('.badges-list h4').slice(2).remove();
    }
}

function isOdd(num) {
  return num % 2 !== 0;
}

function pdpStructureOldBadges() {
    const productElement = $(".product-detail");
    badgesReplace(productElement);
}

function plpStructureBadgesInRecommender() {
   const productElement = $(".product-tile");

    productElement.each(function(index, productTile){
        badgesReplace(productTile);
    });
}

function plpStructureOldBadges() {

    let productElement = $(".product-grid");

    productElement.find('.product-tile').each(function(index, productTile){
        badgesReplace(productTile);
    });

    let productGridCount = $('.product-grid').find('.col-6.col-sm-4').length;
    let allElementsOnGrid = productElement.find('.col-6.col-sm-4');

    allElementsOnGrid.each(function(index, productTileElement) {
        let productTile = $(productTileElement).find('.product-tile');


        let numberOfBadges = $(productTile).find('.badges-list span').length;
        let sizeOfBadges = $(productTile).find('.badges-list').height();

        if (numberOfBadges === 2 && sizeOfBadges > 33) {
            // Get last and next element
            let prevIndex = index - 1;
            let nextIndex = index + 1;

            let prevElement = prevIndex in allElementsOnGrid ? allElementsOnGrid[prevIndex] : null;
            let nextElement = nextIndex in allElementsOnGrid ? allElementsOnGrid[nextIndex] : null;

            let prevElementBadgeSize = $(prevElement).find('.badges-list').height();
            let nextElementBadgeSize = $(nextElement).find('.badges-list').height();

            let classToApply = '';
            if (isOdd(index) && prevElement && prevElementBadgeSize <= 33) {
                classToApply = $(prevElement).find('.badges-list span').length === 0 ? 'badge-margin-botton-double' : 'badge-margin-botton';
                $(prevElement).find('.badges-list').first().addClass(classToApply);
            }

            if (!isOdd(index) && nextElement && nextElementBadgeSize <= 33) {
                classToApply = $(nextElement).find('.badges-list span').length === 0 ? 'badge-margin-botton-double' : 'badge-margin-botton';
                $(nextElement).find('.badges-list').first().addClass(classToApply);
            }
        }
    });

    // plp struct related products
    const relatedProductElement = $('.related-products-container').find('.product-tile');

    relatedProductElement.each(function(index, productTile){
        badgesReplace(productTile);
    });
}


module.exports = {
    init: init,
    plpStructureOldBadges: plpStructureOldBadges,
    plpStructureBadgesInRecommender: plpStructureBadgesInRecommender
};
